/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addCustomersToPool} from '../api'

export const useMutationAddCustomersToPool = createReactQueryMutationHook('addCustomersToPool', addCustomersToPool)
